// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ITbHdXG7kdOt3lQVCMjdh","currency":"_1RcJbqF94ZzwDTEnrGbNgE","icon":"_1ttic2Ft5Xqj8rfAWtJ1jP","content":"_2Sy84cVXKW_qpxjYdt9feg","name":"_3B4u9eHHllHT5KdKu92CfT","price":"ePXP_uscQ9J5EofnPeBc"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Layout/Nav/Currencies/styles.css
// module id = 1647
// module chunks = 83